import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-thermometre-capacite',
  templateUrl: './thermometre-capacite.component.html',
  styleUrls: ['./thermometre-capacite.component.scss'],
  standalone: false
})
export class ThermometreCapaciteComponent {
  @Input()
  minBudget: string | number;

  @Input()
  maxBudget: string | number;

  @Input()
  versementRealiste: number;

  @Input()
  versementMaximal: number;

  @Input()
  fraisPropriete: number;

  @Input()
  isThermometreOnly: boolean;
}
